module.exports = __webpack_public_path__ + "static/media/elect_bike.1d1fa2ef.webp";